<template>
  <div>
    <template v-if="isApplyFirst">
      <ots-tipline :isTopLine="true" v-show="isCanHandle">
        当前批次报名初审截止时间为<span>{{ primaryEndAuditTime }}</span> ,请尽快完成审核
      </ots-tipline>
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
      <ots-table-group-new ref="ots-table" :selectList="teaSelectList" :requestForm="requestForm" @search="search"
        :tableHeader="tableHeader" :tableData="tableData" :tableOption="tableOption" :batchOperBtn="batchOperBtn"
        :isDisabledMultiple="isDisabledMultiple" @handleSelectionChange="bachOper" :pagination="pagination"
        @changeNum="changeNum" @changePage="changePage" @changeCity="changeCityFN"></ots-table-group-new>
    </template>
    <template v-else>
      <router-view />
    </template>
    <ots-custom-dialog :dialog.sync="applyMsgDialog" title="报名信息审核">
      <template v-slot:content>
        <div class="exportDialog">
          <el-form ref="exportForm">
            <el-form-item label="驳回原因">
              <el-input type="textarea" v-model="ruleForm.reason"></el-input>
            </el-form-item>
            <el-form-item label="重新提交报考信息">
              <el-radio-group v-model="ruleForm.flag">
                <el-radio-button :label='0'>允许</el-radio-button>
                <el-radio-button :label='1'>不允许</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="applyMsgDialog = false">取消</el-button>
        <el-button round type="primary" @click="rightAudit">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { getSelectPlanFn, getSinglePlan } from '@/http/modules/examSet/examBatch'
import { examineList, exportExamine, selectList } from "@/http/modules/custom"
export default {
  name: "applyFirst",
  data() {
    return {
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportInfo,
        },
      ],
      primaryEndAudit: "",
      primaryEndAuditTime: '',
      endAuditTime: "",
      applyMsgDialog: false,
      currentPlanId: '',
      ruleForm: {
        isAudit: 1, //1初审 2终审
        flag: 0,
        reason: "",
        planId: "",
        state: 0,
        stuId: "",
      },
      requestForm: {
        page: 1,
        size: 10, //每页条数
        isAudit: 1, //1初审 2终审
        planId: "", //批次Id
        schoolId: "", // 学校
        stationId: "", // 函授站
        orders: "",
        // subjectId: "", //专业
        // level: "", //层次
        stateType: "1", // 审核状态
        photoState: "", // 人身核验状态
        realName: "",
        cardNo: "", //证件号
        phone: "",
      },
      stuIds: [],
      teaSelectList: [
        {
          title: '考试批次',
          type: 'select',
          requestKey: 'planId',
          // isSearch: true,
          label: 'name',
          value: 'id',
          data: [],
          // change: () => {
          //   this.search()
          // }
        },
        {
          title: "审核状态",
          type: "select",
          requestKey: "stateType",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
            {
              id: "1",
              name: "待初审",
            },
            {
              id: "2",
              name: "初审不通过",
            },
            {
              id: "3",
              name: "待终审",
            },
            {
              id: "4",
              name: "终审通过",
            },
            {
              id: "5",
              name: "终审不通过",
            },
          ],
        },
        {
          title: "人身核验状态",
          type: "select",
          isSearch: true,
          requestKey: "photoState",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
            {
              id: 1,
              name: "系统通过",
            },
            {
              id: 0,
              name: "系统不通过",
            },
            {
              id: 2,
              name: "人工通过",
            },
          ],
        },
        {
          title: "院校",
          type: "select",
          isSearch: true,
          requestKey: "schoolId",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
          ],
        },
        {
          title: "函授站",
          type: "select",
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
          ],
        },
        // {
        //   title: "层次",
        //   type: "select",
        //   isSearch: true,
        //   requestKey: "level",
        //   label: "name",
        //   value: "id",
        //   data: [
        //     {
        //       id: "",
        //       name: "全部",
        //     },
        //     {
        //       id: "高起本",
        //       name: "高起本",
        //     },
        //     {
        //       id: "专升本",
        //       name: "专升本",
        //     },
        //     {
        //       id: "自考本科",
        //       name: "自考本科",
        //     },
        //   ],
        // },
        // {
        //   title: "专业",
        //   type: "select",
        //   isSearch: true,
        //   requestKey: "subjectId",
        //   label: "name",
        //   value: "id",
        //   data: [
        //     {
        //       id: "",
        //       name: "全部",
        //     },
        //   ],
        // },
        {
          title: "姓名",
          type: "input",
          requestKey: "realName",
          placeholder: "请输入",
        },
        {
          title: "证件号",
          type: "input",
          requestKey: "cardNo",
          placeholder: "请输入",
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
      ],
      tableHeader: [
        {
          title: "姓名",
          prop: "realName",
          width: "80",
          fixed: "left",
        },
        {
          title: "院校",
          prop: "school",
          width: "200",
        },
        {
          title: "函授站",
          prop: "station",
          width: "200",
        },
        {
          title: "证件号",
          prop: "cardNo",
          width: "200",
        },
        {
          title: "手机号",
          prop: "phone",
          width: "115",
        },
        {
          title: "报考课程",
          prop: "course",
          width: "100",
        },
        {
          title: "照片",
          type: "img",
          prop: "photo",
          fixed: "right",
        },
        {
          title: "人身核验状态",
          prop: "photoState",
          type: "state",
          stateFlag: (scope) => {
            const options = {
              人工通过: "green",
              系统通过: "green",
              系统不通过: "red",
              无照片: "red",
            };
            return options[scope.row.photoState];
          },
          width: "120",
          fixed: "right",
        },
        {
          title: "审核状态",
          prop: "stateType",
          type: "state",
          stateFlag: (scope) => {
            //待初审、初审不通过、待终审、终审通过、终审不通过
            const options = {
              '待初审': 'orange',
              '初审不通过': 'red',
              '待终审': 'orange',
              '终审通过': 'green',
              '终审不通过': 'red',
            }
            return options[scope.row.stateType];
          },
          fixed: "right",
          width: "110",
        },
        {
          title: "操作",
          type: "buttons",
          width: "165",
          fixed: "right",
          btnList: [
            {
              title: (scope) => {
                let { stateType } = scope.row;
                return !(stateType === "待初审" && this.isCanHandle) ? "" : "通过"
              },
              formatter: (scope) => {
                let { stateType } = scope.row
                return !(stateType === "待初审" && this.isCanHandle)
              },
              click: this.pass,
            },
            {
              title: (scope) => {
                let { stateType } = scope.row
                return !(stateType === "待初审" && this.isCanHandle) ? "" : "驳回"
              },
              formatter: (scope) => {
                let { stateType } = scope.row
                return !(stateType === "待初审" && this.isCanHandle)
              },
              click: this.unpass,
            },
            {
              title: (scope) => {
                let { stateType } = scope.row;
                if ((stateType === "待终审" || stateType === "初审不通过") && this.isCanHandle) {
                  return "撤销审核";
                } else {
                  return "";
                }
              },
              click: this.revokeState,
            },
            {
              title: '审核详情',
              click: this.lookDetail,
            },
          ],
        },
      ],
      tableData: [],
      tableOption: {
        multiple: true,
      },
      batchOperBtn: [
        {
          title: "批量审核通过",
          icon: "iconfont icon-kaiqi",
          click: this.exportUser,
        },
      ],
      pagination: {
        total: 0,
      },
      importForm: {
        file: "",
      },
      planInfo: {
        primaryEndAudit: '',
      },
      customSearch: [],
      currentTime: '',
    };
  },
  computed: {
    isApplyFirst() {
      return this.$route.name === 'applyFirst'
    },
    isOverAudit() {
      return new Date(this.currentTime) > new Date(this.primaryEndAudit).getTime()
    },
    isCurrentPlan() {
      return this.requestForm.planId == this.currentPlanId
    },
    isCanHandle() {
      return !this.isOverAudit && this.isCurrentPlan
    }
  },
  watch: {
    '$route.name': function (val) {
      if (val == 'applyFirst') {
        this.search()
      }
    },
    'requestForm.planId': function (val) {
      this.isPlanChange = true
      this.search()
    }
  },
  mounted() {
    this.initData();
    this.isSetState();
  },
  methods: {
    /***********************************
     * @isSetState 系统是否设置了函授站标题
     ***********************************/
    isSetState() {
      this.mixin_getServerTime().then( res => {
        if (res.code == 1) {
          this.currentTime = res.data
        }
      })
      this.teaSelectList[4].title = "函授站";
      this.tableHeader[2].title = "函授站";
    },

    /*****************************************
     * @changeCityFN 子组件传递方法,地址数据处理
     *****************************************/
    changeCityFN(e, attr) {
      this.requestForm[attr] = e.toString();
    },
    /*****************************************
     * @initData 初始化表格,表单数据
     *****************************************/
    initData() {
      this.mixin_setUserExtInfo().then(res => {
        res.data.map(item => {
          // 1. 搜索表单数据
          if (item.queryCondition == 1) {
            if (item.type == 'select' || item.type == 'province' || item.type == 'subject' || item.type == 'nation' || item.type == 'politicalStatus' || item.type == 'level') {
              if (item.valueVo) {
                let search = {
                  title: item.displayName,
                  type: 'select',
                  requestKey: item.name,
                  label: 'name',
                  value: 'name',
                  data: [
                    {
                      name: "全部",
                    },
                    ...item.valueVo
                  ],
                };
                this.customSearch.push(search);
              }
            } else if (item.type == 'text') {
              let search = {
                title: item.displayName,
                type: 'input',
                requestKey: item.name,
                placeholder: '请输入',
              };
              this.customSearch.push(search);
            } else if (item.type == "provinceCity") {
              let search = {
                title: item.displayName,
                type: 'cascader',
                requestKey: item.name,
                label: 'name',
                value: 'name',
                data: [
                  {
                    name: "全部",
                  },
                  ...item.valueVo
                ],
              };
              this.customSearch.push(search);
            };
          };
          // 2. table 表格数据
          if (item.type == 'imageUpload') {
            let tables = {
              title: item.displayName,
              type: 'img',
              width: "120",
              prop: item.name,
            }
            this.tableHeader.push(tables);
          } else {
            let tables = {
              title: item.displayName,
              width: "120",
              prop: item.name,
            }
            this.tableHeader.push(tables);
          };
        });
        this.requestForm = Object.assign(this.requestForm, res.requestForm);
        this.teaSelectList = [...this.teaSelectList, ...this.customSearch];
      });

      // 当前批次
      this.mixin_getCurrentPlanInfo().then((data) => {
        this.currentPlanId = data.id
      })
      // 批次列表
      getSelectPlanFn({ needAudit: 1 }).then(({ data }) => {
        if (data && data.length) {
          this.teaSelectList[0].data = this.teaSelectList[0].data.concat(data)
          this.requestForm.planId = data[0].id
        }
      })
      // 院校列表
      this.mixin_getSelectSchool().then(data => {
        if (data && data.length) {
          this.teaSelectList[3].data = this.teaSelectList[3].data.concat(data)
        }
      })
      // 函授站列表
      this.mixin_getSelectStation().then(data => {
        if (data && data.length) {
          this.teaSelectList[4].data = this.teaSelectList[4].data.concat(data)
        }
      })

    },

    getPlanInfo(planId) {
      getSinglePlan({ planId }).then(({ data }) => {
        this.primaryEndAudit = data.primaryEndAudit
        this.primaryEndAuditTime = moment(data.primaryEndAudit).format('YYYY年MM月DD日 HH时mm分ss秒')
        this.isPlanChange = false
      })
    },
    exportInfo() {
      exportExamine(this.requestForm).then(res => {
        if (res.code == 1) {
          window.location.href = res.data
        }
      })
    },
    pass(val) {
      let { planId, stuid } = val
      this.ruleForm.planId = planId
      this.ruleForm.stuId = stuid
      this.ruleForm.state = 0
      this.examine()
    },
    unpass(val) {
      this.applyMsgDialog = true
      let { planId, stuid } = val
      this.ruleForm.state = 1
      this.ruleForm.planId = planId
      this.ruleForm.stuId = stuid
    },
    rightAudit() {
      this.examine()
    },
    examine() {
      this.$api.applyAudit.examine(this.ruleForm).then(res => {
        if (res.code) {
          this.applyMsgDialog = false
          this.$message({
            message: this.ruleForm.state ? '审核不通过' : "审核通过",
            type: 'success'
          });
          this.getTableList()
        }
      })
    },
    exportUser() {
      if (this.stuIds.length < 1) {
        this.$message({
          message: "请选择要通过的学生",
          type: 'warning'
        });
        return
      }
      this.$confirm(`确认将选中${this.stuIds.length}名学生审核通过`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let queryImport = {
          isAudit: 1,
          planId: this.requestForm.planId,
          stuIds: this.stuIds + ''
        }
        this.$api.applyAudit.batchExamine(queryImport).then(res => {
          if (res.code) {
            this.$message({
              message: "审核通过",
              type: 'success'
            });
            this.getTableList()
          }
        })
      }).catch(() => {
      })
    },
    lookDetail(val) {
      let { planId, stuid } = val
      this.$router.push({
        path: '/applyFirst/applyAuditDetail',
        query: { planId, stuid, isCanHandle: this.isCanHandle }
      })
    },
    revokeState(row) {

      let { planId, stuid } = row

      this.$confirm('确定要撤销审核吗？', '撤销审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$api.applyAudit.backExamineFn({
          isAudit: 1,
          planId,
          stuId: stuid
        })
      }).then((res) => {
        if (res.code) {
          this.$message.success('撤销成功')
          this.getTableList()
        }
      }).catch(() => {
      });

    },
    search() {
      this.requestForm.page = 1
      this.getTableList()
    },
    getTableList() {
      for (let key in this.requestForm) {
        if (this.requestForm[key] == "全部") {
          this.requestForm[key] = '';
        }
      };
      if (this.isPlanChange) {
        this.getPlanInfo(this.requestForm.planId)
      };
      examineList(this.requestForm).then(res => {
        if (res.code) {
          this.tableData = res.data.records
          this.pagination.total = res.data.total
          res.data.records.forEach(e => {
            e.extData.forEach(item => {
              e[item.name] = item.value;
            })
          })
        }

      })
    },
    isDisabledMultiple(row) {
      let { stateType } = row;
      if (stateType == '待初审' && this.isCanHandle) {
        return true
      }
      return false
    },
    bachOper(val) {
      this.stuIds = []
      let idList = []
      val.forEach(item => {
        idList.push(item.stuid)
      })
      this.stuIds = idList
    },
    changeNum(num) {
      this.requestForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getTableList();
    },
  },
};
</script>

<style>
</style>